import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "Section"
};
var _hoisted_2 = {
  "class": "Section__buttons"
};
var _hoisted_3 = {
  "class": "p-xl"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex items-center text-base text-white mb-sm cursor-default"
}, " Amount ", -1);
var _hoisted_5 = {
  "class": "flex range-inputs items-center mb-xl"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  "class": "mr-sm ml-sm"
}, "-", -1);
var _hoisted_7 = {
  "class": "mt-xl mb-xl"
};
var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  "class": "label mb-md"
}, " Status ", -1);
var _hoisted_9 = {
  "class": "statuses flex"
};
var _hoisted_10 = {
  "class": "flex items-center mb-md"
};
var _hoisted_11 = {
  "class": "flex"
};
var _hoisted_12 = {
  "class": "Section"
};
var _hoisted_13 = {
  key: 0,
  "class": "flex items-center pt-2xl px-xl justify-center"
};
var _hoisted_14 = {
  "class": "p-2xl"
};
var _hoisted_15 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-md leading-snug"
}, " Bequant Prime Limited is a limited company registered in Seychelles with registered number 218593 and registered office at House of Francis Room 303, Ile Du Port, Mahe, Seychelles and is an International company. The company does not hold licenses and is therefore not regulated by the MFSA or any other regulatory authority. ", -1);
var _hoisted_16 = {
  "class": "leading-snug"
};
var _hoisted_17 = ["href"];
var _hoisted_18 = {
  "class": "p-2xl"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-md leading-snug"
}, " Earn product is provided by Bequant Prime Limited. Bequant Prime Limited is a limited company registered in Seychelles with registered number 218593 and registered office at House of Francis Room 303, Ile Du Port, Mahe, Seychelles and is an International company. Bequant Prime Limited is not regulated by any specific regulator. ", -1);
var _hoisted_20 = {
  "class": "leading-snug"
};
var _hoisted_21 = ["href"];
import ModalLoader from "@/components/ModalLoader.vue";
import { getFromLocalStorage, saveToLocalStorage, getUniqueListBy } from "@/utils/helpers";
import eventBus from "@/utils/eventbus";
import { GLOBAL_EVENTS } from "@/constants/global-events";

import { defineAsyncComponent, ref, computed, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'Earnings',
  setup: function setup(__props) {
    var EarnDepositModal = defineAsyncComponent({
      loader: function loader() {
        return import("./modals/Deposit.vue");
      },
      loadingComponent: ModalLoader
    });
    var route = useRoute();
    var router = useRouter();
    var store = useStore();
    var TABS = {
      OPTIONS: "Deposit Options",
      ACTIVE: "Active Deposits",
      CLOSED: "History"
    };
    var tabs = [{
      label: TABS.OPTIONS,
      route: "earn"
    }, {
      label: TABS.ACTIVE,
      route: "active-deposits"
    }, {
      label: TABS.CLOSED,
      route: "closed-deposits"
    }];
    var primeBrokerModal = ref(false);
    var depositModal = ref(false);
    var depositModalData = ref(null);
    var loading = ref(true);
    var hideZeroBalances = ref(false);
    var activeTab = ref(TABS.OPTIONS);
    var earnRiskModal = ref(false);
    var currenciesOptions = computed(function () {
      return getUniqueListBy(store.getters["earn/currencies"].reduce(function (acc, curr) {
        if (!acc.includes(curr.currency)) {
          acc.push({
            text: curr.currency,
            value: curr.currency
          });
        }
        return acc;
      }, []), 'value');
    });
    var searchModel = computed({
      get: function get() {
        return store.state.earn.search;
      },
      set: function set(value) {
        store.dispatch("earn/updateSearch", value);
      }
    });
    var currencyModel = computed({
      get: function get() {
        return store.state.earn.currency;
      },
      set: function set(value) {
        store.dispatch("earn/updateCurrency", value);
      }
    });
    var startDateRangeModel = computed({
      get: function get() {
        return store.state.earn.startDateRange;
      },
      set: function set(value) {
        store.dispatch("earn/updateStartDateRange", value);
      }
    });
    var endDateRangeModel = computed({
      get: function get() {
        return store.state.earn.endDateRange;
      },
      set: function set(value) {
        store.dispatch("earn/updateEndDateRange", value);
      }
    });
    var statusesModel = computed({
      get: function get() {
        return store.state.earn.statuses;
      },
      set: function set(value) {
        store.dispatch("earn/updateStatuses", value);
      }
    });
    var amountModel = computed({
      get: function get() {
        return store.state.earn.amounts;
      },
      set: function set(value) {
        store.dispatch("earn/updateAmounts", value);
      }
    });
    var exportCsvData = computed(function () {
      var deposits = store.getters["earn/activeDeposits"];
      if (route.name === "closed-deposits") {
        deposits = store.getters["earn/closedDeposits"];
      }
      return deposits.map(function (deposit) {
        var _deposit$formattedAmo, _deposit$formattedAcc, _deposit$formattedTot;
        return {
          Currency: deposit.currency,
          Amount: (_deposit$formattedAmo = deposit.formattedAmount) === null || _deposit$formattedAmo === void 0 ? void 0 : _deposit$formattedAmo.replace(/,/g, ""),
          Period: deposit.period,
          Rate: "".concat(deposit.rate, "%"),
          "Accrued Interest": (_deposit$formattedAcc = deposit.formattedAccruedInterest) === null || _deposit$formattedAcc === void 0 ? void 0 : _deposit$formattedAcc.replace(/,/g, ""),
          "Start Date": deposit.startDate,
          "End Date": deposit.endDate,
          "Total Amount": (_deposit$formattedTot = deposit.formattedTotalAmount) === null || _deposit$formattedTot === void 0 ? void 0 : _deposit$formattedTot.replace(/,/g, ""),
          Status: deposit.status
        };
      });
    });
    function closeDepositModal() {
      depositModalData.value = null;
      depositModal.value = false;
    }
    function toggleHideZeroBalances() {
      hideZeroBalances.value = !hideZeroBalances.value;
    }
    function closeFirstTimeModal() {
      earnRiskModal.value = false;
      saveToLocalStorage("bq:earn:risk-accepted", true);
    }
    function routerPush(selectedTab) {
      var tab = tabs.find(function (tab) {
        return selectedTab === tab.label;
      });
      if (tab.route === route.name) {
        return;
      }
      router.push({
        name: tab.route
      });
    }
    watch(route, function (value) {
      store.dispatch("earn/resetFilters");
      store.dispatch("earn/updateSearch", "");
      if (value.name === "earn") {
        activeTab.value = TABS.OPTIONS;
      } else if (value.name === "active-deposits") {
        activeTab.value = TABS.ACTIVE;
      } else if (value.name === "closed-deposits") {
        activeTab.value = TABS.CLOSED;
      }
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([store.dispatch("earn/getDepositOptions"), store.dispatch("earn/getDeposits")]);
          case 2:
            loading.value = false;
            if (!getFromLocalStorage("bq:earn:risk-accepted")) {
              earnRiskModal.value = true;
            }
            if (store.getters.hasPermission(store.state.config.userPermissions.MANAGE_EARN)) {
              eventBus.on(GLOBAL_EVENTS.OPEN_EARN_DEPOSIT_MODAL, function (data) {
                depositModalData.value = data;
                depositModal.value = true;
              });
            }
            if (!(route.name === "active-deposits")) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", activeTab.value = TABS.ACTIVE);
          case 7:
            if (route.name === "closed-deposits") {
              activeTab.value = TABS.CLOSED;
            }
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_FiltersButton = _resolveComponent("FiltersButton");
      var _component_PBSelect = _resolveComponent("PBSelect");
      var _component_PBInput = _resolveComponent("PBInput");
      var _component_DatePicker = _resolveComponent("DatePicker");
      var _component_PBCheckbox = _resolveComponent("PBCheckbox");
      var _component_PBButton = _resolveComponent("PBButton");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      var _component_Search = _resolveComponent("Search");
      var _component_ExportCsvButton = _resolveComponent("ExportCsvButton");
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_Tooltip = _resolveComponent("Tooltip");
      var _component_PBTab = _resolveComponent("PBTab");
      var _component_RouterView = _resolveComponent("RouterView");
      var _component_PBTabs = _resolveComponent("PBTabs");
      var _component_PBPopup = _resolveComponent("PBPopup");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_unref(route).name !== 'history-deposits' ? (_openBlock(), _createBlock(_component_PBTabs, {
        key: 0,
        modelValue: _unref(activeTab),
        "onUpdate:modelValue": [_cache[11] || (_cache[11] = function ($event) {
          return _isRef(activeTab) ? activeTab.value = $event : null;
        }), routerPush]
      }, {
        top: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_unref(route).name !== 'earn' ? (_openBlock(), _createBlock(_component_PBDropdown, {
            key: 0,
            selectable: false,
            chevron: false,
            scroll: false,
            left: "",
            width: "480px"
          }, {
            icon: _withCtx(function () {
              return [_createVNode(_component_FiltersButton, {
                label: false
              })];
            }),
            menu: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_PBSelect, {
                modelValue: _unref(currencyModel),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _isRef(currencyModel) ? currencyModel.value = $event : null;
                }),
                label: "Currency",
                placeholder: "Choose currency",
                options: _unref(currenciesOptions),
                "class": "mb-xl",
                multi: ""
              }, null, 8, ["modelValue", "options"]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_PBInput, {
                modelValue: _unref(amountModel).from,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _unref(amountModel).from = $event;
                }),
                placeholder: "From"
              }, null, 8, ["modelValue"]), _hoisted_6, _createVNode(_component_PBInput, {
                modelValue: _unref(amountModel).to,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _unref(amountModel).to = $event;
                }),
                placeholder: "To"
              }, null, 8, ["modelValue"])]), _createVNode(_component_DatePicker, {
                modelValue: _unref(startDateRangeModel),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return _isRef(startDateRangeModel) ? startDateRangeModel.value = $event : null;
                }),
                label: "Select Start Range of Dates",
                "class": "mb-xl"
              }, null, 8, ["modelValue"]), _createVNode(_component_DatePicker, {
                modelValue: _unref(endDateRangeModel),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return _isRef(endDateRangeModel) ? endDateRangeModel.value = $event : null;
                }),
                label: "Select End Range of Dates"
              }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_unref(route).name === 'active-deposits' ? (_openBlock(), _createBlock(_component_PBCheckbox, {
                key: 0,
                modelValue: _unref(statusesModel).Processing,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                  return _unref(statusesModel).Processing = $event;
                }),
                label: "Processing",
                "class": "mr-md"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _unref(route).name === 'closed-deposits' ? (_openBlock(), _createBlock(_component_PBCheckbox, {
                key: 1,
                modelValue: _unref(statusesModel).Rejected,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _unref(statusesModel).Rejected = $event;
                }),
                label: "Rejected",
                "class": "mr-md"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_PBCheckbox, {
                modelValue: _unref(statusesModel).Executed,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return _unref(statusesModel).Executed = $event;
                }),
                label: "Executed"
              }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_PBButton, {
                "class": "ml-auto",
                bordered: "",
                onClick: _cache[8] || (_cache[8] = function ($event) {
                  return _unref(store).dispatch('earn/resetFilters');
                })
              }, {
                "default": _withCtx(function () {
                  return [_createTextVNode(" Reset ")];
                }),
                _: 1
              }), _createVNode(_component_PBButton, {
                "class": "ml-md",
                onClick: _cache[9] || (_cache[9] = function ($event) {
                  return _unref(store).dispatch('earn/updateFilters');
                })
              }, {
                "default": _withCtx(function () {
                  return [_createTextVNode(" Apply ")];
                }),
                _: 1
              })])])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_Search, {
            modelValue: _unref(searchModel),
            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
              return _isRef(searchModel) ? searchModel.value = $event : null;
            }),
            placeholder: "Search",
            "class": _normalizeClass({
              'ml-xl': _unref(route).name !== 'earn'
            })
          }, null, 8, ["modelValue", "class"]), _unref(route).name !== 'earn' ? (_openBlock(), _createBlock(_component_ExportCsvButton, {
            key: 1,
            "class": "ml-xl",
            data: _unref(exportCsvData),
            name: _unref(route).name
          }, null, 8, ["data", "name"])) : _createCommentVNode("", true), _unref(activeTab) === TABS.OPTIONS ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 2,
            text: "".concat(_unref(hideZeroBalances) ? 'Show' : 'Hide', " 0 balances"),
            "class": "ml-xl"
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_PBIcon, {
                name: _unref(hideZeroBalances) ? 'eye' : 'eye-off',
                w: 26,
                h: 26,
                onClick: toggleHideZeroBalances
              }, null, 8, ["name"])];
            }),
            _: 1
          }, 8, ["text"])) : _createCommentVNode("", true)])];
        }),
        "default": _withCtx(function () {
          return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, function (tab, index) {
            return _createVNode(_component_PBTab, {
              key: index,
              label: tab.label
            }, null, 8, ["label"]);
          }), 64)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_RouterView, {
            loading: _unref(loading),
            "hide-zero-balances": _unref(hideZeroBalances)
          }, null, 8, ["loading", "hide-zero-balances"])])];
        }),
        _: 1
      }, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_RouterView, {
        key: 1
      })), _unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.MANAGE_EARN) && _unref(depositModal) ? (_openBlock(), _createBlock(_unref(EarnDepositModal), {
        key: 2,
        tariff: _unref(depositModalData),
        onClose: closeDepositModal
      }, null, 8, ["tariff"])) : _createCommentVNode("", true)]), _unref(route).name !== 'history-deposits' && _unref(route).name !== 'earn' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createTextVNode(" Earn product is provided by Bequant Prime Limited "), _createVNode(_component_PBIcon, {
        name: "external-link",
        w: 18,
        h: 18,
        "class": "ml-lg cursor-pointer broker-modal-icon",
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return primeBrokerModal.value = true;
        })
      })])) : _createCommentVNode("", true), _createVNode(_component_PBPopup, {
        "is-open": _unref(primeBrokerModal),
        title: "Bequant Prime Limited",
        "class": "WideModal",
        onClose: _cache[13] || (_cache[13] = function ($event) {
          return primeBrokerModal.value = false;
        })
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("p", _hoisted_16, [_createTextVNode(" The cryptocurrency services offered by Bequant Prime Limited are unregulated, as a result you will not benefit from any investor compensation scheme or backing by any central bank. Cryptocurrencies are highly volatile and subject to price fluctuations, and therefore provide an investment risk. You should carefully assess whether your financial situation and tolerance for risk is suitable for any form of exposure to cryptocurrencies as any investment may be lost. BEQUANT does not guarantee the accuracy of the information provided on this website. Any use or reliance on our content and services is solely at your own risk and discretion. For further information please see "), _createElementVNode("a", {
            href: _unref(store).getters['earn/termsOfUseUrl'],
            "class": "text-primary border-b border-solid border-primary"
          }, "Terms of Use", 8, _hoisted_17), _createTextVNode(". ")])])];
        }),
        _: 1
      }, 8, ["is-open"]), _createVNode(_component_PBPopup, {
        "is-open": _unref(earnRiskModal),
        title: "Risk Warning",
        "class": "WideModal",
        "close-btn": false,
        "header-close-btn": false
      }, {
        content: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("p", _hoisted_20, [_createTextVNode(" The cryptocurrency services offered by Bequant Prime Limited are unregulated, as a result you will not benefit from any investor compensation scheme or backing by any central bank. Cryptocurrencies are highly volatile and subject to price fluctuations, and therefore provide an investment risk. You should carefully assess whether your financial situation and tolerance for risk is suitable for any form of exposure to cryptocurrencies as any investment may be lost. BEQUANT does not guarantee the accuracy of the information provided on this website. Any use or reliance on our content and services is solely at your own risk and discretion. For further information please see "), _createElementVNode("a", {
            href: _unref(store).getters['earn/termsOfUseUrl'],
            "class": "text-primary border-b border-solid border-primary"
          }, "Terms of Use", 8, _hoisted_21), _createTextVNode(". ")])])];
        }),
        footer: _withCtx(function () {
          return [_createVNode(_component_PBButton, {
            onClick: closeFirstTimeModal
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(" I understand ")];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["is-open"])]);
    };
  }
};